<template>
    <BaseModal
        ref="BaseModal"
        :title="title"
    >
        <div class="font-weight-bold">
            Deseja realmente passar a fase deste ticket?
        </div>
        <template v-slot:footer>
            <div class="btn btn-primary" @click="confirm()">Passar fase</div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../components/BaseModal'

export default {
    name: 'ConfirmNext',
    components: {BaseModal},
    props: {
        title: {String, default: 'Mudança de Fase'}
    },
    methods: {
        show (callback) {
            this.$refs.BaseModal.show()
            this.callback = callback
        },
        confirm () {
            this.callback()
            this.$refs.BaseModal.hide()
        }
    }
}
</script>

<style scoped>

</style>
